/*
This is a list of Google XDP slugs for products that were created before we switched
to a "view template" pattern vs duplicating existing prof certs for the Google XDP page.
We want to defend against redirecting to these slugs since they lead to valid products
that we don't want to surface. This should be temporary as we investigate deprecating the products.

More details here: https://docs.google.com/document/d/11KlTqV01aEsvELNx8OzQlqrw5fkKPLPjeLBifbyBmI0/edit
*/
export const GOOGLE_XDP_SLUGS = [
  'data-analytics-certificate',
  'digital-marketing-certificate',
  'it-automation-certificate',
  'it-support-certificate',
  'project-management-certificate',
  'ux-design-certificate',
  'cybersecurity-certificate',
  'advanced-data-analytics-certificate',
  'business-intelligence-certificate',
  'certificado-analise-de-dados',
  'certificado-analisis-de-datos',
  'sertifikat-analitik-data',
  'certificat-analytique-des-donnees',
  'certificat-conception-ux',
  'data-analytics-certificate-japanese',
  'sertifikat-desain-ux',
  'certificado-diseno-de-experiencia-del-usuario-ux',
  'certificado-gestao-de-projetos',
  'certificat-gestion-de-projet',
  'certificat-gestion-de-projet-fr',
  'certificado-gestion-de-proyectos',
  'data-analytics-certificate-arabic',
  'data-analytics-certificate-de',
  'digital-marketing-ecomm-certificate-ua',
  'it-certificate-arabic',
  'it-certificate-de',
  'certificado-it-pt2',
  'it-certificate-ru',
  'it-support-certificate-ua',
  'sertifika-proje-yonetimi',
  'project-management-certificate-arabic',
  'project-management-certificate-de',
  'ux-design-certificate-arabic',
  'ux-design-certificate-de',
  'sertifikat-it-support-profesional',
  'certificado-soporte-de-tecnologias-de-informacion',
  'certificat-soutien-des-ti',
  'certificado-suporte-em-ti',
  'certificat-support-informatique',
  'certificado-ux-design',
  'sertifikat-analitik-data',
  'marketing-digital-e-e-commerce-do-certificado',
  'certificado-de-carrera-de-marketing-digital-e-e-commerce',
  'sertifikat-manajemen-proyek',
];

/*
This is a mapping of google XDP slugs -> professional certificate source. We have this so we 
can redirect to a canonical source if one of these slugs is trying to be accessed at the
/specializations or /professional-certificates path. The slugs here are tied to duplciated
actual products that we want to deprecate/stop enrollments on. 

This spreadsheet https://docs.google.com/spreadsheets/d/1MW9tMiBJ_fTCLIbB9kAlU0Bt0dUeD691VlIt5aEIQZA/edit#gid=0 
is the true source of Google XDP slugs, but it can be larger than this list as we no longer create duplicate products 
for the Google XDP. This list is for the products that were duplicated and is static.
*/
export const GOOGLE_XDP_SLUG_TO_PROF_CERT = {
  'data-analytics-certificate': 'google-data-analytics',
  'digital-marketing-certificate': 'google-digital-marketing-ecommerce',
  'it-automation-certificate': 'google-it-automation',
  'it-support-certificate': 'google-it-support',
  'project-management-certificate': 'google-project-management',
  'ux-design-certificate': 'google-ux-design',
  'cybersecurity-certificate': 'google-cybersecurity',
  'advanced-data-analytics-certificate': 'google-advanced-data-analytics',
  'business-intelligence-certificate': 'google-business-intelligence',
  'certificado-analise-de-dados': 'analise-de-dados-do-google',
  'certificado-analisis-de-datos': 'analisis-de-datos-de-google',
  'sertifikat-analitik-data': 'analitik-data-google',
  'certificat-analytique-des-donnees': 'analytique-des-donnees-google',
  'certificat-conception-ux': 'conception-ux-google',
  'data-analytics-certificate-japanese': 'data-analytics-japanese',
  'sertifikat-desain-ux': 'desain-ux-google',
  'certificado-diseno-de-experiencia-del-usuario-ux': 'diseno-de-experiencia-del-usuario-ux-de-google',
  'certificado-gestao-de-projetos': 'gestao-de-projetos-do-google',
  'certificat-gestion-de-projet': 'gestion-de-projet-de-google',
  'certificat-gestion-de-projet-fr': 'gestion-de-projet-google',
  'certificado-gestion-de-proyectos': 'gestion-de-proyectos-de-google',
  'data-analytics-certificate-arabic': 'google-data-analytics-arabic',
  'data-analytics-certificate-de': 'google-data-analytics-de',
  'digital-marketing-ecomm-certificate-ua': 'google-digital-marketing-ecommerce-ua',
  'it-certificate-arabic': 'google-it-arabic',
  'it-certificate-de': 'google-it-de',
  'certificado-it-pt2': 'google-it-pt2',
  'it-certificate-ru': 'google-it-ru',
  'it-support-certificate-ua': 'google-it-support-ua',
  'sertifika-proje-yonetimi': 'google-proje-yonetimi',
  'project-management-certificate-arabic': 'google-project-management-arabic',
  'project-management-certificate-de': 'google-project-management-de',
  'ux-design-certificate-arabic': 'google-ux-design-arabic',
  'ux-design-certificate-de': 'google-ux-design-de',
  'sertifikat-it-support-profesional': 'sertifikat-it-support-profesional-google',
  'certificado-soporte-de-tecnologias-de-informacion': 'soporte-de-tecnologias-de-informacion-google',
  'certificat-soutien-des-ti': 'soutien-des-ti-de-google',
  'certificado-suporte-em-ti': 'suporte-em-ti-do-google',
  'certificat-support-informatique': 'support-informatique-google',
  'certificado-ux-design': 'ux-design-do-google',
  'certificado-de-carrera-de-marketing-digital-e-e-commerce':
    'certificado-de-carrera-de-google-marketing-digital-e-e-commerce',
  'marketing-digital-e-e-commerce-do-certificado': 'marketing-digital-e-e-commerce-do-google',
  'sertifikat-manajemen-proyek': 'manajemen-proyek-google',
};
